import React, {Component} from "react";
import * as func from "../../../../../utils/functions";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import {BASE_PATH} from "../../../../../wpconfig";
import ResourceItem from "../../../../resource/front/list/ResourceItem2";
import {NavLink} from "react-router-dom";
import Loading from "../../../../etc/loading";

class SResources extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit: false,
			param: {
				'current_page': 1,
				'record_per_page': 5,
				'scholar_id': func.getParams("record_id"),
				'ks': '',
				'sub_ks': '',
				'collabo_org': [],
				'cited_count': [],
				'resource_type': [],
				'publisher': [],
				'registered_db_name': [],
				'dept': [],
				'registered_db_year': [],
				'scholar': [],
				'author_count': [],
				'order_by': 'date',
				'order': 'desc',
			},
			action: 'resources',
			records: [],
			totalRecords: 0
		}

		this.getList();
	}

	getList() {
		func.getData(this.state.action, this.state.param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				totalRecords: response.pageInfo.totalResults
			})
		});
	}

	render() {
		// const record = this.props.record;
		// const meta = parent.meta;
		const url = objectToQueryString({
			'scholar_id' : this.state.param.scholar_id,
		});

		return (
			<div className="mt-65">
				{!this.state.isInit ? <Loading/> :
					this.state.records.length > 0 &&
					<>
						<div className="d-flex justify-content-between align-items-center mb-px-26">
							<div className="d-flex align-items-center">
								<h3 className="con-title">저자가 발표한 다른 논문</h3>
							</div>
						</div>
						<div>
							<div className="line-list-group">
								{this.state.records.map((record, index) => {
									const no = this.state.totalRecords - ((this.state.param.current_page - 1) * this.state.param.record_per_page) - index;
									return (
										<ResourceItem key={index} record={record} no={no}/>
									)
								})}
							</div>
						</div>
						{this.state.totalRecords > 5 &&
						<div className="mt-4">
							<div className="text-center">
								<NavLink to={BASE_PATH + 'resources/?' + url}
								         className="btn btn-outline-gray btn-lg">
									<span className="icon icon-size-24 icon-plus-black align-top mr-2"/>
									<strong>논문 전체보기</strong>
								</NavLink>
							</div>
						</div>
						}
					</>
				}
			</div>
		);
	}
};

export default SResources;
